module.exports = __webpack_public_path__ + "img/9.e4549f45.jpg";